// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__DC8Rq","text":"style_text__fIMDa"};